
import { Link } from "react-router-dom"

function SettingsCard({ icon, name, text, onClick, addclass, link }) {
    return (
      <>
        {link && (
          <Link to={link} className={`settingcard ${addclass} noLink`} onClick={onClick}>
            {icon}
            <div className="ms-3">
                <h6 className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>{name}</h6>
                <p className="mb-0 fw-bold text-secondary" style={{fontSize: '14px'}}>{text}</p>
            </div>
          </Link>
        )}
        {!link && (
          <div className={`settingcard ${addclass}`} onClick={onClick}>
            {icon}
            <div className="ms-3">
                <h6 className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>{name}</h6>
                <p className="mb-0 fw-bold text-secondary" style={{fontSize: '14px'}}>{text}</p>
            </div>
          </div>
        )}
      </>
    )
  }
  
  export default SettingsCard